(function (root) {
  function setIcons(toggle, isOpen) {
    var iconIndex = 0;

    Array.prototype.forEach.call(toggle.children, function (child) {
      if (!child.classList.contains("inline-flex")) {
        return;
      }

      child.classList.toggle("hidden", iconIndex !== (isOpen ? 1 : 0));
      iconIndex += 1;
    });
  }

  function initHeader(header, toggle, menuLinks) {
    var mobileMediaQuery = window.matchMedia("(max-width: 1299px)");
    var previousScrollY = Math.max(0, window.scrollY);
    var scrollTicking = false;

    function showHeader() {
      header.classList.remove("is-scroll-hidden");
    }

    function updateHeaderVisibility() {
      var currentScrollY = Math.max(0, window.scrollY);
      var scrollDelta = currentScrollY - previousScrollY;

      scrollTicking = false;

      if (currentScrollY <= window.innerHeight || header.classList.contains("is-menu-open")) {
        showHeader();
        previousScrollY = currentScrollY;
      } else if (scrollDelta > 4) {
        header.classList.add("is-scroll-hidden");
        previousScrollY = currentScrollY;
      } else if (scrollDelta < -4) {
        showHeader();
        previousScrollY = currentScrollY;
      }
    }

    function handleScroll() {
      if (scrollTicking) return;

      scrollTicking = true;
      window.requestAnimationFrame(updateHeaderVisibility);
    }

    function setStoreState(isOpen) {
      if (root.Alpine && root.Alpine.store) {
        if (mobileMediaQuery.matches) {
          root.Alpine.store("storefront").navMenuOpened = isOpen;
          return;
        }

        root.Alpine.store("storefront").navMenuOpened =
          !root.Alpine.store("storefront").cartOpened;
      }
    }

    function setMenuState(isOpen) {
      header.classList.toggle("is-menu-open", isOpen);
      if (isOpen) showHeader();
      menuLinks.classList.toggle("is-active", isOpen);
      toggle.classList.toggle("is-active", isOpen);
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
      if (mobileMediaQuery.matches) {
        menuLinks.setAttribute("aria-hidden", String(!isOpen));
        menuLinks.toggleAttribute("inert", !isOpen);
      } else {
        menuLinks.removeAttribute("aria-hidden");
        menuLinks.removeAttribute("inert");
      }
      setIcons(toggle, isOpen);
      setStoreState(isOpen);
    }

    function preventShopNavigationOnMobile(link) {
      link.addEventListener("click", function (event) {
        if (
          window.matchMedia("(max-width: 1299px)").matches &&
          link.dataset.id === "shop"
        ) {
          event.preventDefault();
        }
      });
    }

    toggle.setAttribute("aria-expanded", "false");
    setMenuState(false);
    window.addEventListener("scroll", handleScroll, { passive: true });

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      setMenuState(!header.classList.contains("is-menu-open"));
    });

    header.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && header.classList.contains("is-menu-open")) {
        event.preventDefault();
        setMenuState(false);
        toggle.focus();
      }
    });

    if (mobileMediaQuery.addEventListener) {
      mobileMediaQuery.addEventListener("change", function () {
        setMenuState(false);
      });
    }

    document.addEventListener("click", function (event) {
      if (!header.classList.contains("is-menu-open")) {
        return;
      }

      if (header.contains(event.target)) {
        return;
      }

      setMenuState(false);
    });

    menuLinks.querySelectorAll("a").forEach(function (link) {
      if (link.dataset.id === "shop") {
        preventShopNavigationOnMobile(link);
      }

      link.addEventListener("click", function () {
        if (
          window.matchMedia("(max-width: 1299px)").matches &&
          link.dataset.id === "shop"
        ) {
          return;
        }

        if (link.closest(".site-menu-links-nav") && link.dataset.hasSubmenu === "true") {
          return;
        }

        setMenuState(false);
      });
    });
  }

  function initVanilla() {
    var header = document.querySelector(".site-header");
    var toggle = document.querySelector(".nav-link-toggle");
    var menuLinks = document.querySelector(".site-menu-links");

    if (!header || !toggle || !menuLinks) {
      return;
    }

    initHeader(header, toggle, menuLinks);
  }

  function initJQuery($) {
    $(function () {
      var $header = $(".site-header");
      var $toggle = $(".nav-link-toggle");
      var $menuLinks = $(".site-menu-links");

      if (!$header.length || !$toggle.length || !$menuLinks.length) {
        return;
      }

      initHeader($header.get(0), $toggle.get(0), $menuLinks.get(0));
    });
  }

  if (root.jQuery) {
    initJQuery(root.jQuery);
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVanilla);
  } else {
    initVanilla();
  }
})(window);
